module.exports = __webpack_public_path__ + "resources/img/solution_commerce_rescue4_m.81d075aab83b815bdf53a055749d5f18.png";